import styled from 'styled-components'

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  background: ${({ theme }) => theme.colors.invert};
  color: ${({ theme }) => theme.colors.default};
  padding: 50px;
  align-items: center;

  .content {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1400px;
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 10px 0 25px;
  }

  .infoWrapper {
    right: 0;
    margin-left: auto;
    margin-right: 100px;
    position: relative;
    display: inline-block;
  }

  .infoWrapper .text {
    visibility: hidden;
    width: 240px;
    background-color: #555;
    color: ${({ theme }) => theme.colors.invert};
    text-align: center;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -120px;
    opacity: 0;
    transition: opacity 1s;
  }

  .infoWrapper .text::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  .infoWrapper:hover .text {
    visibility: visible;
    opacity: 1;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Styled/Pages.tsx